// extracted by mini-css-extract-plugin
export var cartIcon = "_nq-0";
export var cartIconContainer = "_nq-1";